import { select, call, put } from 'redux-saga/effects';
import { getHistory } from 'utils/history';
import { sortTree } from 'utils/tree';
import api_v2 from 'services/api_v2';
import OrderActions, { OrderSelectors } from './OrderRedux';
import AppActions, { AppSelectors } from './AppRedux';
import { AuthSelectors } from './AuthRedux';
import { PaySelectors } from './PayRedux';

export function* initializeCart(action) {
  const { venueId } = action;
  const ticketVenueId = yield select(AppSelectors.selectVenue);
  const ticketItems = yield select(PaySelectors.selectItems);
  const ticket = yield select(PaySelectors.selectTicket);

  if (ticketVenueId && ticketVenueId !== venueId) {
    yield put(
      AppActions.setToast('Ticket is already open on other venue', 'danger')
    );
    return;
  }

  yield put(OrderActions.resetCart());

  const history = getHistory();
  console.log('ticket  items', ticketItems);

  if (ticket) {
    for (let i = 0; i < ticketItems.length; i += 1) {
      yield put(
        OrderActions.addItemToCart(
          venueId,
          ticketItems[i].quantity,
          ticketItems[i]
        )
      );
    }
    history.push(`/locations/${venueId}/cart/review`);
  } else {
    history.push(`/locations/${venueId}/cart/add`);
  }
}

export function* loadMenuItems(action) {
  try {
    const { venueId, forced } = action;
    const isLoaded = yield select(OrderSelectors.selectIsLoaded(venueId));
    if (isLoaded && !forced) {
      return;
    }

    const token = yield select(AuthSelectors.selectToken);
    const api = api_v2(token);

    yield put(OrderActions.setMenuItemsLoading(true));
    const menuItemResult = yield call(api.getMenuItems, venueId);
    const categoryResult = yield call(api.getMenuCategories, venueId);

    yield put(OrderActions.setMenuItems(venueId, menuItemResult));

    yield put(
      OrderActions.setMenuCategories(venueId, sortTree(categoryResult))
    );

    yield put(OrderActions.setMenuItemsLoading(false));
  } catch (error) {
    yield put(
      AppActions.setToast(
        error.message || 'There was problem loading menu',
        'danger'
      )
    );
  } finally {
    yield put(OrderActions.setMenuItemsLoading(false));
  }
}

export function* sendOrder(action) {
  try {
    const { venueId, locationId } = action;
    const cartItems = yield select(OrderSelectors.selectCartItems(venueId));
    const token = yield select(AuthSelectors.selectToken);
    const api = api_v2(token);

    if (!cartItems.length) {
      yield put(AppActions.setToast('Please add items to cart', 'danger'));
      return;
    }

    const currentTicket = yield select(PaySelectors.selectTicket);

    if (currentTicket) {
      yield put(OrderActions.setSendingOrder(true));

      console.log('Cart Items: ', locationId, cartItems);

      const cartItemParams = cartItems.map((item) => ({
        id: item.item.id,
        groupId: item.item.groupId,
        quantity: item.quantity,
        modifiers: item.modifiers,
      }));

      const addItemParam = {
        locationId,
        items: cartItemParams,
      }

      console.log('Add Item params: ', addItemParam);

      const checkId = currentTicket.checks[0].id;

      const addItemResult = yield call(
        api.addItems,
        venueId,
        checkId,
        addItemParam
      );

      console.log('Add Item result: ', addItemResult);

      yield put(OrderActions.resetCart());
      yield put(OrderActions.setSendingOrder(false));
    } else {
      yield put(AppActions.setToast('Please open the ticket again.', 'danger'));
    }
  } catch (err) {
    yield put(
      AppActions.setToast(
        err.message || 'There was problem sending order',
        'danger'
      )
    );
  } finally {
    yield put(OrderActions.setSendingOrder(false));
  }
}
